"use strict";

var _interopRequireDefault = require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addUser = addUser;
exports.changeState = changeState;
exports.getUser = getUser;
exports.getUserList = getUserList;
exports.getUserSelectList = getUserSelectList;
exports.updateUser = updateUser;
var _request = _interopRequireDefault(require("@/utils/request"));
function getUserList(data) {
  return (0, _request.default)({
    url: '/api/v1/user',
    method: 'get',
    params: data
  });
}
function getUserSelectList() {
  return (0, _request.default)({
    url: '/api/v1/system/select_list/user',
    method: 'get'
  });
}
function getUser(id) {
  return (0, _request.default)({
    url: "/api/v1/user/".concat(id),
    method: 'get'
  });
}
function addUser(data) {
  return (0, _request.default)({
    url: '/api/v1/user',
    method: 'post',
    data: data
  });
}
function updateUser(data) {
  return (0, _request.default)({
    url: "/api/v1/user/".concat(data.id),
    method: 'patch',
    data: data
  });
}
function changeState(data) {
  return (0, _request.default)({
    url: "/api/v1/user/".concat(data.id),
    method: 'post',
    data: data
  });
}